import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';

//API
import tipoDeFiscalizacao_api from '../../../api/tipoDeFIscalizacao_api';
import confirmacaoInfrator_api from '../../../api/confirmacaoInfrator_api';

//Helpers
import { showMessage } from '../../../helpers/message';
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';

//Context
import { useAuth } from '../../../context/auth';

//Components
import TextField from '../../../components/TextField';
import IndicarInfrator from './components/IndicarInfrator';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Shared
import AutoDeFiscalizacao from '../../Shared/AutoDeFiscalizacao';

function ConfirmacaoInfratores() {
  //State para pegar lista infratores com base na fiscalização
  const [consultaInfratores, setConsultaInfratores] = useState({
    tipoFiscalizacao_Id: ''
  });

  //State para pegar lista dos tipos de fiscalização
  const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

  //State para lista infratores das fiscalizações
  const [listFiscalizacoesInfratores, setListFiscalizacoesInfratores] = useState([]);

  //State para visualizar a ficha de fiscalização
  const [visualizarFiscalizacao_id, setVisualizarFiscalizacao_id] = useState(null);

  //State para indicar infrator
  const [indicarInfrator, setIndicarInfrator] = useState(null);

  //Estado de controle dos campos de erro
  const [errors, setErrors] = useState({});

  const { setLoading } = useAuth();

  const loadTipoDeFiscalizacao = () => {
    setLoading(true);
    tipoDeFiscalizacao_api.getList()
      .then(response => {
        setListTipoDeFiscalizacao(response.data)
      })
      .catch(err => showMessage("Aviso", err.message, "error", null))
      .finally(() => setLoading(false));
  };


  useEffect(() => {
    loadTipoDeFiscalizacao();
  }, []);

  //Estado de controle dos campos obrigatorios 
  const [campos, setCampos] = useState([
    objCampo({ name: "tipoFiscalizacao_Id", required: true })
  ]);

  //Cabeçalhos da lista de consulta infração
  const headers = [
    { value: "Tipo de Fiscalização", objectValue: "tipoFiscalizacao_Identificacao", align: "left" },
    {
      value: "Data da Fiscalização", objectValue: "dataFiscalicao", align: "left", options: {
        customBodyRenderLite: (dataIndex) => {
          return <>{moment(listFiscalizacoesInfratores[dataIndex].dataFiscalicao).format("DD/MM/YYYY")}</>
        }
      }
    },
    { value: "Usuário", objectValue: "usuario_Nome", align: "left" },
    { value: "Endereço", objectValue: "enderecoCompleto", align: "left" }
  ];

  const visualizarFiscalizacao = (fiscalizacao) => {
    setVisualizarFiscalizacao_id(fiscalizacao.id ?? 1);
  }

  const visualizarinfrator = (item) => {
    setIndicarInfrator(item);

  }

  //Variavel que guarda as ações da tabela
  const actions = [actionsTable.visualizar(visualizarFiscalizacao), actionsTable.dinamico(faUserPlus, visualizarinfrator)];

  const onChangeTipoFiscalizacao = (value, e) => {
    const _consultaInfratores = {
      ...consultaInfratores,
      [e.name]: value ? value.value : null,
    };

    //Validando erros no campo especifico para checar em tempo de digitação se ele possui algum erro
    const _campos = campos.filter(campo => campo.name === e.name);
    const fieldError = validarCampos(_consultaInfratores, _campos);

    const _errors = { ...errors };
    delete _errors[e.name];
    if (fieldError[1].length === 0)
      setErrors({ ..._errors });
    else
      setErrors({ ..._errors, ...fieldError[0] });

    setConsultaInfratores(_consultaInfratores);
  }

  const handleVoltar = () => {
    setVisualizarFiscalizacao_id(null);
  }

  // função para buscar todas as infraçoes 
  const handleTipoFiscalizacao = () => {
    //Realizando a validação dos campos obrigatorios
    const _errors = validarCampos(consultaInfratores, campos);
    setErrors(_errors[0]);

    if (_errors[1].length > 0)
      return true;

    setLoading(true);
    confirmacaoInfrator_api.GetConfirmacaoInfratores(consultaInfratores.tipoFiscalizacao_Id)
      .then(response => {
        setListFiscalizacoesInfratores(response.data)
      })
      .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
      .finally(() => setLoading(false));
  }


  if (visualizarFiscalizacao_id) {
    return <AutoDeFiscalizacao
      id={visualizarFiscalizacao_id}
      handleVoltar={handleVoltar}
    />
  }


  return <>
    {indicarInfrator && <IndicarInfrator indicarInfrator={indicarInfrator} setIndicarInfrator={setIndicarInfrator}/>}
    <h4 className='text-secondary m-0'>Confirmação de Infratores</h4>
    <Row className='mt-3'>
      <Col md={12} lg={6}>
        <TextField
          type={"select"}
          name={"tipoFiscalizacao_Id"}
          label={"* Tipo de Ficalização"}
          searchable
          options={listTipoDeFiscalizacao.map(v => { return { value: v.id.toString(), label: v.identificacao.toString() } })}
          onChange={onChangeTipoFiscalizacao}
          value={
            listTipoDeFiscalizacao.filter(value => value.id == consultaInfratores.tipoFiscalizacao_Id)
              .map(v => { return { value: v.id.toString(), label: v.identificacao.toString() } })
          }
          invalid={!!errors.tipoFiscalizacao_Id}
        />
      </Col>
      <Col md={12} lg={4} className='mt-2'>
        <Button
          color='primary'
          className='text-white fw-bold'
          onClick={handleTipoFiscalizacao}
        >
          <FontAwesomeIcon icon={faFilter} /> Filtrar
        </Button>
      </Col>
    </Row>
    <Row>
      <TabelaListagem
        actions={actions}
        title={`Lista de fiscalização`}
        options={{ print: false, search: true, pagination: true }}
        headers={headers}
        items={listFiscalizacoesInfratores}
      />
    </Row>
  </>;
}

export default ConfirmacaoInfratores;